import raftRestClient from "../../lib/raft_rest_client";

const state = {
  recBuildingList: [],
  recSpaceList: [],
  recGroupList: [],
  recBenchList: [],
  recShelfList: [],
  recSelectedBuildings: [],
  recSelectedSpace: [],
  recSelectedGroup: [],
  recSelectedBench: "",
  recSelectedShelf: "",
  reconciliationId: 0,
  reconciliationState: 0,
  containerTableFilter: "",
  recContainerIds: "",
  recBenchFilter: "",
  recShelfFilter: "",
  recSpecificLocationNoteFilter: "",
  recUpdatedAfterFilter: "",
  recUpdatedBeforeFilter: "",
  chemicalReconciliation: {},
  chemicalReconciliationCacheExp: 0,
  // This is the default time in ms after which we re-fetch the reconciliation data.
  chemicalReconciliationCacheExpDefault: 15 * 60 * 1000,
  tableContainers: [],
  tableContainersNotFound: [],
  chemicalContainerCount: null,
  showFoundContainers: true,
  spacesWithChemicals: [],
  spaceRelatedOrgs: [],
  spaceRelatedBenches: [],
  spaceRelatedShelves: [],
  recHistoryDateBefore: "",
  recHistoryDateAfter: "",
  reconciliationSteps: [],
  selMoveGroup: [],
  // @todo use this set: [0, 100, 200, 500, 1000],
  reconciliationStepsNoBarcode: [0, 100, 200, 500, 1000],
  reconciliationStepsBarcode: [0, 100, 200, 300, 400, 500, 1000],
  trickyContainerIds: {},
  unmatchedContainerIdsHash: "",
  containerIdsSubmitSpinning: false,
  reconciliationError: "",
};

const getters = {
  getReconciliationId: (state) => state.reconciliationId,
  getReconciliationState: (state) => state.reconciliationState,
  getChemicalReconciliation: (state) => state.chemicalReconciliation,
  getTableContainers: (state) => state.tableContainers,
  getTableContainersNotFound: (state) => state.tableContainersNotFound,
  getChemicalContainerCount: (state) => state.chemicalContainerCount,
  getShowFoundContainers: (state) => state.showFoundContainers,
  getContainerTableFilter: (state) => state.containerTableFilter,
  getRecBuildingList: (state) => state.recBuildingList,
  getRecSpaceList: (state) => state.recSpaceList,
  getRecGroupList: (state) => state.recGroupList,
  getRecSelectedBench: (state) => state.recSelectedBench,
  getRecSelectedShelf: (state) => state.recSelectedShelf,
  getRecSelectedBuildings: (state) => state.recSelectedBuildings,
  getRecSelectedSpace: (state) => state.recSelectedSpace,
  getRecSelectedGroup: (state) => state.recSelectedGroup,
  getRecSpecificLocationNoteFilter: (state) =>
    state.recSpecificLocationNoteFilter,
  getRecUpdatedAfterFilter: (state) => state.recUpdatedAfterFilter,
  getRecUpdatedBeforeFilter: (state) => state.recUpdatedBeforeFilter,
  getSpacesWithChemicals: (state) => state.spacesWithChemicals,
  getSpaceRelatedOrgs: (state) => state.spaceRelatedOrgs,
  getSpaceRelatedBenches: (state) => state.spaceRelatedBenches,
  getSpaceRelatedShelves: (state) => state.spaceRelatedShelves,
  getRecHistoryDateBefore: (state) => state.recHistoryDateBefore,
  getRecHistoryDateAfter: (state) => state.recHistoryDateAfter,
  getRecContainerIds: (state) => state.recContainerIds,
  getChemicalReconciliationCacheExp: (state) =>
    state.chemicalReconciliationCacheExp,
  getReconciliationSteps: (state) => state.reconciliationSteps,
  getSelMoveGroup: (state) => state.selMoveGroup,
  getTrickyContainerIds: (state) => state.trickyContainerIds,
  getUnmatchedContainerIdsHash: (state) => state.unmatchedContainerIdsHash,
  getContainerIdsSubmitSpinning: (state) => state.containerIdsSubmitSpinning,
  getReconciliationError: (state) => state.reconciliationError,
};

const mutations = {
  setReconciliationId: (state, reconciliationId) =>
    (state.reconciliationId = reconciliationId),
  setReconciliationState: (state, reconciliationState) =>
    (state.reconciliationState = reconciliationState),
  setChemicalReconciliation: (state, chemicalReconciliation) =>
    (state.chemicalReconciliation = chemicalReconciliation),
  setTableContainers: (state, chemicalContainers) =>
    (state.tableContainers = chemicalContainers),
  setChemicalContainerCount: (state, count) =>
    (state.chemicalContainerCount = count),
  setTableContainersNotFound: (state, chemicalContainers) =>
    (state.tableContainersNotFound = chemicalContainers),
  setShowFoundContainers: (state, showBool) =>
    (state.showFoundContainers = showBool),
  setContainerTableFilter: (state, filterText) =>
    (state.containerTableFilter = filterText),
  setRecBuildingList: (state, buildList) => (state.recBuildingList = buildList),
  setRecSpaceList: (state, spaceList) => (state.recSpaceList = spaceList),
  setRecGroupList: (state, groupList) => (state.recGroupList = groupList),
  setRecSelectedBuildings: (state, buildList) =>
    (state.recSelectedBuildings = buildList),
  setRecSelectedSpace: (state, spaceList) =>
    (state.recSelectedSpace = spaceList),
  setRecSelectedGroup: (state, groupList) =>
    (state.recSelectedGroup = groupList),
  setRecSelectedBench: (state, benchList) =>
    (state.recSelectedBench = benchList),
  setRecSelectedShelf: (state, shelfList) =>
    (state.recSelectedShelf = shelfList),
  setSelMoveGroup: (state, moveGroup) => (state.selMoveGroup = moveGroup),
  setRecBenchFilter: (state, benchFil) => (state.recBenchFilter = benchFil),
  setRecShelfFilter: (state, shelfFil) => (state.recShelfFilter = shelfFil),
  setRecSpecificLocationNoteFilter: (state, noteFil) =>
    (state.recSpecificLocationNoteFilter = noteFil),
  setRecUpdatedAfterFilter: (state, aftFil) =>
    (state.recUpdatedAfterFilter = aftFil),
  setRecUpdatedBeforeFilter: (state, befFil) =>
    (state.recUpdatedBeforeFilter = befFil),
  setSpacesWithChemicals: (state, spacesWithChemicals) =>
    (state.spacesWithChemicals = spacesWithChemicals),
  setSpaceRelatedOrgs: (state, spaceRelatedOrgs) =>
    (state.spaceRelatedOrgs = spaceRelatedOrgs),
  setSpaceRelatedBenches: (state, spaceRelatedBenches) =>
    (state.spaceRelatedBenches = spaceRelatedBenches),
  setSpaceRelatedShelves: (state, spaceRelatedShelves) =>
    (state.spaceRelatedShelves = spaceRelatedShelves),
  setRecHistoryDateBefore: (state, date) => (state.recHistoryDateBefore = date),
  setRecHistoryDateAfter: (state, date) => (state.recHistoryDateAfter = date),
  setRecContainerIds: (state, textData) => (state.recContainerIds = textData),
  setChemicalReconciliationCacheExp: (state, timestamp) =>
    (state.chemicalReconciliationCacheExp = timestamp),
  setReconciliationSteps: (state, steps) => (state.reconciliationSteps = steps),
  setTrickyContainerIds: (state, trickyContainerIds) =>
    (state.trickyContainerIds = trickyContainerIds),
  setUnmatchedContainerIdsHash: (state, hash) =>
    (state.unmatchedContainerIdsHash = hash),
  setContainerIdsSubmitSpinning: (state, value) =>
    (state.containerIdsSubmitSpinning = value),
  setReconciliationError: (state, message) =>
    (state.reconciliationError = message),
};

const actions = {
  updateReconciliationError({ commit }, error) {
    let message = error.message;
    if (error.data) {
      // This is for the JSON:API case.
      if (error.data.hasOwnProperty("errors")) {
        for (const item of error.data.errors) {
          if (item.hasOwnProperty("detail")) {
            message += ". " + item.detail;
          }
        }
      }
      // This is for Drupal core responses.
      if (typeof error.data === "string") {
        // Strip HTML tags that appear in exception messages.
        const div = document.createElement("div");
        div.innerHTML = error.data;
        message += ". " + div.innerText;
      } else if (error.data.hasOwnProperty("message")) {
        message += ". " + error.data.message;
      }
    }
    commit("setReconciliationError", message);
  },
  fetchChemicalReconciliation({ state, dispatch }) {
    if (
      !Number.isInteger(state.reconciliationId) ||
      state.reconciliationId < 1
    ) {
      return;
    }
    const url = "/raft/chemical-reconciliation/" + state.reconciliationId;
    raftRestClient.getBase(
      url,
      {},
      (data) => {
        dispatch(
          "updateReconciliationCacheExp",
          state.chemicalReconciliationCacheExpDefault,
        );
        dispatch("updateChemicalReconciliation", data);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  updateChemicalReconciliation({ state, commit }, data) {
    commit("setChemicalReconciliation", data);
    commit("setReconciliationState", parseInt(data.state[0].value));
    if (
      data.hasOwnProperty("enter_container_ids") &&
      data.enter_container_ids.length === 1 &&
      data.enter_container_ids[0].value === true
    ) {
      commit("setReconciliationSteps", state.reconciliationStepsBarcode);
    } else {
      commit("setReconciliationSteps", state.reconciliationStepsNoBarcode);
    }
  },
  fetchTrickyContainerIds({ state, dispatch }) {
    const url =
      "/chemical-reconciliation/" + state.reconciliationId + "/container-ids";
    raftRestClient.getRest(
      url,
      {},
      (data) => {
        dispatch("updateTrickyContainerIds", data);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  fetchInactiveContainers({ state, dispatch }) {
    const url =
      "/chemical-reconciliation/" +
      state.reconciliationId +
      "/reactivate-containers";
    raftRestClient.getRest(
      url,
      {},
      (data) => {
        dispatch("updateTableContainers", data.inactive_containers);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  fetchMoveContainers({ state, commit, rootState, dispatch }) {
    const url =
      "/chemical-reconciliation/" + state.reconciliationId + "/move-containers";
    raftRestClient.getRest(
      url,
      {},
      (data) => {
        dispatch("updateTableContainers", data.movable_containers);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  updateTableContainers({ state, commit, rootState, dispatch }, containers) {
    commit("setTableContainers", containers);
    dispatch("updateChemicalContainersFound");
  },
  updateChemicalContainersFound({ state, commit }) {
    const not_found_containers = [];
    const containers = state.tableContainers || [];
    for (let i = 0, len = containers.length; i < len; i++) {
      if (containers[i].found === false || containers[i].found === 0) {
        not_found_containers[i] = containers[i];
      }
    }
    commit("setTableContainersNotFound", not_found_containers);
  },
  fetchReconciliationChemicalContainersCount(
    { state, commit, dispatch },
    groupNid,
  ) {
    const chemical_recon_count_url = "/chemical-reconciliation/count-query/";
    commit("setChemicalContainerCount", null);
    let selectedSpace = 0;
    const slnFilter = state.recSpecificLocationNoteFilter;
    const upBeforeFilter = state.recUpdatedBeforeFilter;
    const upAfterFilter = state.recUpdatedAfterFilter;
    const shelfFilter = state.recSelectedShelf;
    const benchFilter = state.recSelectedBench;
    let owningGroup = 0;
    if (state.recSelectedSpace === null) {
      return;
    }
    if (typeof state.recSelectedSpace === "object") {
      selectedSpace = state.recSelectedSpace.nid;
    }
    if (state.recSelectedSpace.length === 1) {
      selectedSpace = state.recSelectedSpace[0].nid;
    }
    if (state.recSelectedGroup) {
      if (
        typeof state.recSelectedGroup === "object" &&
        state.recSelectedGroup.hasOwnProperty("nid")
      ) {
        owningGroup = state.recSelectedGroup.nid;
      } else if (
        state.recSelectedGroup.length === 1 &&
        state.recSelectedGroup[0].hasOwnProperty("nid")
      ) {
        owningGroup = state.recSelectedGroup[0].nid;
      }
    }

    if (typeof selectedSpace === "undefined" || selectedSpace < 1) {
      return;
    }

    const url = chemical_recon_count_url + selectedSpace;
    const queries = {};

    if (owningGroup > 1) {
      queries.owning_group = owningGroup;
    }
    if (benchFilter.length > 0) {
      queries.bench = benchFilter;
    }
    if (shelfFilter.length > 0) {
      queries.shelf = shelfFilter;
    }
    if (slnFilter.length > 0) {
      queries.location_note = slnFilter;
    }
    if (typeof upBeforeFilter === "object" && upBeforeFilter) {
      queries.last_confirmed_before = upBeforeFilter.getTime() / 1000;
    }
    if (typeof upAfterFilter === "object" && upAfterFilter) {
      queries.last_confirmed_after = upAfterFilter.getTime() / 1000;
    }
    // Set group context for access control.
    if (groupNid) {
      queries["rog-id"] = groupNid;
      queries["rog-type"] = "node";
    }
    raftRestClient.getRest(
      url,
      queries,
      (data) => {
        commit("setChemicalContainerCount", data.count);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  createChemicalReconciliation({ state, commit, dispatch }, opts) {
    const enterIds = opts.enterIds;
    const groupNid = opts.groupNid;
    let selectedSpace = "";
    let owningGroup = "";
    let upBeforeFilter = state.recUpdatedBeforeFilter;
    let upAfterFilter = state.recUpdatedAfterFilter;
    // Space is required. Check if single/multiple.
    if (typeof state.recSelectedSpace === "object") {
      selectedSpace = state.recSelectedSpace.uuid;
    }
    if (state.recSelectedSpace.length === 1) {
      selectedSpace = state.recSelectedSpace[0].uuid;
    }
    if (selectedSpace.length < 1 || typeof selectedSpace === "undefined") {
      return;
    }

    const reconciliationData = {};

    let rogQueries = "";
    if (groupNid) {
      rogQueries = "?rog-type=node&rog-id=" + groupNid;
    }
    // This will be set correctly in the single group context.
    if (state.recSelectedGroup) {
      // Handle multiple/single selected groups.
      // @todo We only need to handle the single case.
      if (typeof state.recSelectedGroup === "object") {
        owningGroup = state.recSelectedGroup.uuid;
      } else if (state.recSelectedGroup.length === 1) {
        owningGroup = state.recSelectedGroup[0].uuid;
      }
      if (typeof owningGroup !== "undefined" && owningGroup.length > 0) {
        reconciliationData.owning_group = [
          {
            target_uuid: owningGroup,
          },
        ];
      }
    }
    if (
      typeof state.recSelectedBench === "string" &&
      state.recSelectedBench.length > 0
    ) {
      reconciliationData.bench_location = [{ value: state.recSelectedBench }];
    }
    if (
      typeof state.recSelectedShelf === "string" &&
      state.recSelectedShelf.length > 0
    ) {
      reconciliationData.shelf_location = [{ value: state.recSelectedShelf }];
    }
    if (state.recSpecificLocationNoteFilter.length > 0) {
      reconciliationData.room_location = [
        { value: state.recSpecificLocationNoteFilter },
      ];
    }
    if (enterIds) {
      reconciliationData.enter_container_ids = [{ value: true }];
    }
    if (typeof upBeforeFilter === "object" && upBeforeFilter) {
      upBeforeFilter = upBeforeFilter.getTime() / 1000;
      reconciliationData.last_confirmed_before = [{ value: upBeforeFilter }];
    }
    if (typeof upAfterFilter === "object" && upAfterFilter) {
      upAfterFilter = upAfterFilter.getTime() / 1000;
      reconciliationData.last_confirmed_after = [{ value: upAfterFilter }];
    }
    reconciliationData.space = [
      {
        target_uuid: selectedSpace,
      },
    ];

    raftRestClient.postBase(
      "/entity/chemical_reconciliation" + rogQueries,
      reconciliationData,
      (data) => {
        if (data.hasOwnProperty("id")) {
          commit("setReconciliationId", data.id[0].value);
          commit("setReconciliationState", data.state[0].value);
        }
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  patchReconciliationContainerFound({ state, dispatch }, data) {
    const found_path =
      "/chemical-reconciliation/" +
      state.reconciliationId +
      "/container-found/" +
      data.newState;
    raftRestClient.patchRest(
      found_path,
      data.containers,
      (data) => {
        // @todo: set found flags based on response.
        const updated_containers = Array.from(data.updated_containers).map(
          (x) => parseInt(x, 10),
        );
        const found = data.found === 1;
        if (updated_containers.length > 0) {
          const containers = state.chemicalReconciliation.chemical_containers;
          for (let i = 0, len = containers.length; i < len; i++) {
            if (!containers[i] || !containers[i].hasOwnProperty("target_id")) {
              continue;
            }
            if (updated_containers.includes(containers[i].target_id)) {
              containers[i].found = found;
            }
          }
          // Is this needed if the table containers and rec containers are the same object?
          dispatch(
            "updateTableContainers",
            state.chemicalReconciliation.chemical_containers,
          );
          // Refresh from back end in 30 seconds.
          dispatch("updateReconciliationCacheExp", 30 * 1000);
        }
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  patchReconciliationContainerIgnored({ state, commit, dispatch }, data) {
    const found_url =
      "/chemical-reconciliation/" +
      state.reconciliationId +
      "/container-ignored/" +
      data.newState.toString();
    raftRestClient.patchRest(
      found_url,
      data.containers,
      (data) => {
        const containers = state.tableContainersNotFound;
        const updated_containers = Array.from(data.updated_containers).map(
          (x) => parseInt(x, 10),
        );
        for (let i = 0, len = containers.length; i < len; i++) {
          if (!containers[i] || !containers[i].hasOwnProperty("target_id")) {
            continue;
          }
          if (updated_containers.includes(containers[i].target_id)) {
            // @see \Drupal\chemical_inventory_reconciliation\Plugin\Field\FieldType\ChemicalReconciliationContainerItem::NOT_FOUND_IGNORED
            // Use bitwise operators to set the ignored flag on or off.
            if (data.ignored === true) {
              containers[i].association_type =
                containers[i].association_type | 8;
            }
            if (data.ignored === false) {
              containers[i].association_type =
                containers[i].association_type & ~8;
            }
          }
        }
        dispatch("updateChemicalContainersFound");
        // Refresh from back end in 30 seconds.
        dispatch("updateReconciliationCacheExp", 30 * 1000);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  syncTableContainers({ state, commit, rootState, dispatch }, data) {
    const found = Boolean(data.newState);
    const containers = state.tableContainers;
    for (let i = 0, len = containers.length; i < len; i++) {
      if (!containers[i] || !containers[i].hasOwnProperty("target_id")) {
        continue;
      }
      if (data.containers.includes(containers[i].target_id)) {
        containers[i].found = found;
      }
    }
    dispatch("updateTableContainers", containers);
  },
  patchTableContainers({ state, commit, dispatch }) {
    const containers = state.tableContainers;
    let data = [];
    const found_containers = [];
    for (let i = 0, len = containers.length; i < len; i++) {
      if (!containers[i] || !containers[i].hasOwnProperty("target_id")) {
        continue;
      }
      if (containers[i].found) {
        found_containers.push(containers[i].target_id);
      }
    }

    // @todo - what if containers is empty here?
    let url = "/chemical-reconciliation/" + state.reconciliationId;
    if (state.reconciliationState === 300) {
      url += "/reactivate-containers";
      data = found_containers;
    } else if (state.reconciliationState === 400) {
      url += "/move-containers";
      data = {
        node_ids: found_containers,
        move_group: 0,
      };
      if (
        state.selMoveGroup &&
        typeof state.selMoveGroup === "object" &&
        state.selMoveGroup.hasOwnProperty("nid")
      ) {
        data.move_group = state.selMoveGroup.nid;
      }
    } else {
      console.error("Unexpected state value: " + state.reconciliationState);
      return;
    }

    raftRestClient.patchRest(
      url,
      data,
      (data) => {
        if (data.hasOwnProperty("chemical_reconciliation")) {
          commit("setChemicalReconciliation", data.chemical_reconciliation);
          commit(
            "setReconciliationState",
            data.chemical_reconciliation.state[0].value,
          );
          dispatch(
            "updateReconciliationCacheExp",
            state.chemicalReconciliationCacheExpDefault,
          );
        }
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  patchChemicalReconciliationState({ state, commit, dispatch }, newState) {
    const stateUrl =
      "/chemical-reconciliation/" +
      state.reconciliationId +
      "/state/" +
      newState;
    raftRestClient.patchRest(
      stateUrl,
      {},
      (data) => {
        if (data.hasOwnProperty("chemical_reconciliation")) {
          commit("setChemicalReconciliation", data.chemical_reconciliation);
          commit(
            "setReconciliationState",
            data.chemical_reconciliation.state[0].value,
          );
          dispatch(
            "updateReconciliationCacheExp",
            state.chemicalReconciliationCacheExpDefault,
          );
        }
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  addReconciliationContainerIds({ state, dispatch }) {
    const data = state.recContainerIds.trim();
    if (data === "") {
      return;
    }
    const url =
      "/chemical-reconciliation/" + state.reconciliationId + "/container-ids";
    raftRestClient.patchRest(
      url,
      [data],
      (data) => {
        const containers = state.tableContainers;
        if (data.hasOwnProperty("updated_containers")) {
          // The response data is contains string node IDs, so map to int.
          const updated_containers = Array.from(data.updated_containers).map(
            (x) => parseInt(x, 10),
          );
          for (let i = 0, len = containers.length; i < len; i++) {
            if (updated_containers.includes(containers[i].target_id)) {
              containers[i].found = true;
            }
          }
          dispatch("updateChemicalContainersFound");
          // Refresh from back end in 30 seconds.
          dispatch("updateReconciliationCacheExp", 30 * 1000);
        }
        dispatch("updateTrickyContainerIds", data);
        dispatch("resetRecContainerIds");
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  updateRecSpaceList({ commit }, value) {
    commit("setRecSpaceList", value);
  },
  updateRecGroupList({ commit }, value) {
    commit("setRecGroupList", value);
  },
  updateRecBenchList({ commit }, value) {
    commit("setRecBenchList", value);
  },
  updateRecShelfList({ commit }, value) {
    commit("setRecShelfList", value);
  },
  updateRecSelectedBuildings({ commit }, value) {
    commit("setRecSelectedBuildings", value);
  },
  updateRecSelectedSpace({ commit }, value) {
    commit("setRecSelectedSpace", value);
  },
  updateRecSelectedGroup({ commit }, value) {
    commit("setRecSelectedGroup", value);
  },
  updateRecSelectedBench({ commit }, value) {
    commit("setRecSelectedBench", value);
  },
  updateRecSelectedShelf({ commit }, value) {
    if (!value) {
      value = [];
    }
    commit("setRecSelectedShelf", value);
  },
  updateRecSpecificLocationNoteFilter({ commit }, value) {
    commit("setRecSpecificLocationNoteFilter", value);
  },
  updateRecUpdatedAfterFilter({ commit }, value) {
    commit("setRecUpdatedAfterFilter", value);
  },
  updateRecUpdatedBeforeFilter({ commit }, value) {
    commit("setRecUpdatedBeforeFilter", value);
  },
  recFetchBuildingList({ commit, dispatch }) {
    raftRestClient.getRest(
      "/buildings",
      {},
      (data) => {
        commit("setRecBuildingList", data.buildings);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  fetchSpacesWithChemicalsList({ state, commit, dispatch }, group_id) {
    const queries = {};
    if (state.recSelectedBuildings.hasOwnProperty("nid")) {
      queries.parent_location = state.recSelectedBuildings.nid;
    }
    if (group_id && group_id > 0) {
      queries.owning_group = group_id;
    }
    raftRestClient.getRest(
      "/spaces_with_chemicals",
      queries,
      (data) => {
        commit("setSpacesWithChemicals", data.spaces_with_chemicals);
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  fetchSpaceGroupList({ state, commit, dispatch }) {
    let space = 0;
    let move_group_uuid = null;
    if (typeof state.recSelectedSpace === "object") {
      space = state.recSelectedSpace.nid;
    }
    if (state.recSelectedSpace.length === 1) {
      space = state.recSelectedSpace[0].nid;
    }
    if (
      state.chemicalReconciliation.hasOwnProperty("space") &&
      state.chemicalReconciliation.space.length
    ) {
      space = state.chemicalReconciliation.space[0].target_id;
      if (state.chemicalReconciliation.move_group.length) {
        move_group_uuid =
          state.chemicalReconciliation.move_group[0].target_uuid;
      }
    }
    raftRestClient.getRest(
      "/chemical_owning_groups/" + space,
      {},
      (data) => {
        commit("setSpaceRelatedOrgs", data.chemical_owning_groups);
        for (const group of data.chemical_owning_groups) {
          if (group.uuid === move_group_uuid) {
            commit("setSelMoveGroup", group);
          }
        }
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  fetchSpaceBenchShelfList({ state, commit, dispatch }) {
    let space = 0;
    if (typeof state.recSelectedSpace === "object") {
      space = state.recSelectedSpace.nid;
    }
    if (state.recSelectedSpace.length === 1) {
      space = state.recSelectedSpace[0].nid;
    }
    raftRestClient.getRest(
      "/chemical_bench_shelf_in_spaces",
      { space_nids: [space] },
      (data) => {
        commit(
          "setSpaceRelatedBenches",
          data.chemical_bench_shelf_in_spaces.bench_list,
        );
        commit(
          "setSpaceRelatedShelves",
          data.chemical_bench_shelf_in_spaces.shelf_list,
        );
      },
      (message, data) =>
        dispatch("updateReconciliationError", { message, data }),
      this,
    );
  },
  recClearListedSpaces({ commit }) {
    commit("setRecSpaceList", []);
    commit("setRecSelectedSpace", []);
  },
  resetSelectedGroup({ commit }) {
    commit("setRecSelectedGroup", []);
  },
  resetSelectedBench({ commit }) {
    commit("setRecSelectedBench", "");
  },
  resetSelectedShelf({ commit }) {
    commit("setRecSelectedShelf", "");
  },
  updateRecHistoryDateBefore({ commit }, value) {
    commit("setRecHistoryDateBefore", value);
  },
  updateRecHistoryDateAfter({ commit }, value) {
    commit("setRecHistoryDateAfter", value);
  },
  updateRecContainerIds({ commit }, value) {
    commit("setRecContainerIds", value);
  },
  resetRecContainerIds({ commit }) {
    commit("setRecContainerIds", "");
  },
  updateTrickyContainerIds({ commit }, data) {
    const oldhash = state.unmatchedContainerIdsHash
      ? state.unmatchedContainerIdsHash
      : "old";
    let newhash = "new";
    if (data.hasOwnProperty("unmatched_container_ids_hash")) {
      newhash = data.unmatched_container_ids_hash;
    }
    if (oldhash === newhash) {
      return;
    }
    const trickyContainerIds = {};
    const type_list = [
      "forbidden_containers",
      "inactive_containers",
      "move_containers",
      "unknown_containers",
    ];
    for (const type of type_list) {
      if (data[type] && data[type].length) {
        trickyContainerIds[type] = data[type];
      }
    }
    commit("setTrickyContainerIds", trickyContainerIds);
    commit("setUnmatchedContainerIdsHash", newhash);
  },
  updateReconciliationCacheExp({ state, commit, rootState, dispatch }, delay) {
    // Delay is in ms.
    const newExpTime = new Date().getTime() + delay;
    const expTime = state.chemicalReconciliationCacheExp;
    // Use the new value if sooner than prior value.
    if (newExpTime < expTime || expTime === 0) {
      commit("setChemicalReconciliationCacheExp", newExpTime);
    }
  },
  chemicalReconciliationLastFetchedCheck({ state, commit, dispatch }) {
    const currentDate = new Date().getTime();
    const expTime = state.chemicalReconciliationCacheExp;
    if (currentDate >= expTime) {
      commit(
        "setChemicalReconciliationCacheExp",
        new Date().getTime() + state.chemicalReconciliationCacheExpDefault,
      );
      dispatch("fetchChemicalReconciliation");
    }
  },
};

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions,
};
